import { CardItem, CardItemLabel, CardItemContent, CardItemValue } from '../ui/details-card';
import { MapPin, Phone } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { formatPhoneNumber } from '../../lib/utils';

const HospitalDetails = props => {
  const { data = {} } = props;
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-5'>
        <div className='w-full flex flex-col md:flex-row gap-5 md:gap-10 md:justify-between'>
            <CardItem>
                <CardItemLabel>{t('Name')}</CardItemLabel>
                <CardItemContent>
                    <CardItemValue>{data?.providerName}</CardItemValue>
                </CardItemContent>
            </CardItem>
            <CardItem>
                <CardItemLabel>{t('Address')}</CardItemLabel>
                <CardItemContent>
                    <div><MapPin size={28} strokeWidth={1} className='text-primary'/></div>
                    <CardItemContent className='flex flex-col gap-1'>
                        <CardItemValue>{data?.providerAddress1}{data?.providerAddress2 ? `, ${data?.providerAddress2}` : ''}</CardItemValue>
                        <CardItemValue>{data?.providerCity}, {data?.providerState} {data?.providerZip}</CardItemValue>
                    </CardItemContent>
                </CardItemContent>
            </CardItem>
            <CardItem>
                <CardItemLabel>{t('Phone Number')}</CardItemLabel>
                <CardItemContent>
                    <div><Phone size={28} strokeWidth={1} className='text-primary'/></div>
                    <CardItemValue>{(data?.providerPhone ? <a href={`tel:${data.providerPhone}`} className='underline text-gray-800 hover:text-gray-800 font-normal'>{formatPhoneNumber(data?.providerPhone)}</a> : null)}</CardItemValue>
                </CardItemContent>
            </CardItem>
        </div>
        <div className='w-full flex flex-col md:flex-row gap-5 md:gap-10 md:justify-between'>
            <CardItem>
                <CardItemLabel>{t('Accreditation Status')}</CardItemLabel>
                <CardItemContent>
                    <CardItemValue>
                        {data?.accreditations?.length > 0 ? (
                            <ul className='flex flex-col gap-1'>
                                {data?.accreditations.map((item) => <li>{item}</li>)}
                            </ul>
                        ) : t('Not Available')}
                    </CardItemValue>
                </CardItemContent>
            </CardItem>
        </div>
    </div>
  );
};

export default HospitalDetails;
